var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-xl"},[_vm._v("历史版本")]),_c('hr',{staticClass:"my-4"}),_c('SpaceOpener',[_c('SpaceVersions')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }